import { TrackByService } from '@abp/ng.core';
import { Component, Input } from '@angular/core';
import { AssetDetailsDto } from '@proxy/register-service/assets';

@Component({
  selector: 'app-attributes',
  templateUrl: './attributes.component.html',
  styleUrls: ['./attributes.component.scss'],
})
export class AttributesComponent {
  @Input() asset: AssetDetailsDto;

  qrImageSrc: string | ArrayBuffer | null = null;

  constructor(public readonly track: TrackByService) {}

  get attributes() {
    return this.asset?.attributes ?? [];
  }

  get meters() {
    return this.asset?.meters ?? [];
  }
}
